import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";

interface PageLayoutProps {
  children: React.ReactNode;
  isHomePage?: boolean;
}

export const PageLayout = ({ children, isHomePage = false }: PageLayoutProps) => {
  return (
    <div className="min-h-screen bg-background">
      <Navigation isHomePage={isHomePage} />
      <div className={isHomePage ? "" : "pt-20"}>
        {children}
      </div>
      <Footer />
    </div>
  );
};